import { CMRSpecialCargoTypeTypeEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { Text } from '@shared/components'
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography
} from 'antd'
import { Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

const { Title } = Typography

export const SpecialCargoTypes = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const form = Form.useFormInstance()

  const { specialCargoTypesProps } = formProps(t)

  const revalidateShares = () => {
    form
      .validateFields([specialCargoTypesProps.name], { recursive: false })
      .catch(() => undefined)
  }

  const specialCargoTypeOptions = Object.values(
    CMRSpecialCargoTypeTypeEnum
  ).map((v) => ({
    label: t(v),
    value: v
  }))

  return (
    <>
      <Title level={5}>{t('special_cargo_types')}</Title>

      <Form.List
        name={specialCargoTypesProps.name}
        rules={[
          {
            validator: async (_, value) => {
              if (!value?.length) {
                return Promise.reject(
                  new Error(t('add_at_least_one_special_cargo'))
                )
              }

              const totalShare = value.reduce(
                (sum: number, item: { share?: number }) =>
                  sum + (Number(item?.share) || 0),
                0
              )

              if (totalShare !== 100) {
                return Promise.reject(
                  new Error(t('special_cargo_share_must_total_100'))
                )
              }
            }
          }
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map(({ key, name }) => (
              <Row key={key} gutter={[12, 0]} align="middle">
                <Col xs={24} lg={8}>
                  <Form.Item
                    name={[name, 'type']}
                    label={t('category')}
                    rules={[required]}
                  >
                    <Select
                      placeholder={t('category')}
                      options={specialCargoTypeOptions}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={8}>
                  <Form.Item name={[name, 'details']} label={t('details')}>
                    <Input placeholder={t('details')} />
                  </Form.Item>
                </Col>

                <Col xs={20} lg={6}>
                  <Form.Item name={[name, 'share']} label={t('share')}>
                    <InputNumber
                      style={{ width: '100%' }}
                      min={0}
                      max={100}
                      placeholder={t('share')}
                      onChange={revalidateShares}
                    />
                  </Form.Item>
                </Col>

                <Col xs={4} lg={2}>
                  <Form.Item label=" ">
                    <Button
                      type="text"
                      danger
                      icon={<Trash size={16} />}
                      onClick={() => remove(name)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}

            <Space direction="vertical" style={{ width: '100%' }}>
              {errors.map((error, index) => (
                <Text key={index} type="danger">
                  {error}
                </Text>
              ))}
              <Button type="dashed" block onClick={() => add()}>
                + {t('add_special_cargo')}
              </Button>
            </Space>
          </>
        )}
      </Form.List>
    </>
  )
}
